import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getWebhooks } from "../../api/apiWebhooks";

export const useGetWebhooks = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["webhooks", params, i18next.language],
        queryFn: () => getWebhooks(params),
        keepPreviousData: true,
    });
    console.log("🚀 ~ useGetWebhooks ~ data:", data?.data)

    // Backend may return either {data: [...], meta: {...}} or a plain
    // array. Be defensive — `items.map is not a function` would otherwise
    // crash the table when the shape is the raw array.
    const list = Array.isArray(data) ? data : (data?.data?.data ?? []);
    const webhooks = Array.isArray(list) ? list : [];
    const meta = data?.data?.meta || {
        current_page: 1,
        per_page: params?.per_page || 15,
        total: webhooks.length,
    };

    return { webhooks, meta, isLoading, error, refetch };
};
